import type { GhostTag, SelectResultFn } from "../../types";

interface TagListItemProps {
  tag: GhostTag;
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function TagListItem({
  tag,
  selectedResult,
  setSelectedResult,
}: TagListItemProps) {
  const { name, url, id } = tag;
  let className =
    "flex items-center py-3 -mx-4 sm:-mx-7 px-4 sm:px-7 cursor-pointer";
  if (id === selectedResult) {
    className += " bg-neutral-100";
  }
  return (
    <div
      className={className}
      onClick={() => {
        if (url) {
          window.location.href = url;
        }
      }}
      onMouseEnter={() => setSelectedResult(id)}
    >
      <p className="mr-2 text-sm font-bold text-neutral-400">#</p>
      <h2 className="text-[1.65rem] font-medium leading-tight text-neutral-900 truncate">
        {name}
      </h2>
    </div>
  );
}
